






















































import {Component, Vue, Watch} from 'vue-property-decorator';
import VendorBox from '@/components/Views/Vendor/VendorBox.vue';
import {Call, Sync} from 'vuex-pathify';
import {DateTime} from 'luxon';
import {BOOKING_HOURS, CALENDAR_FORMAT, getStoreSettings, nil} from '@/common';
import HourPicker from '@/components/Views/Booking Flow/HourPicker.vue';
import RotatingHeader from '@/components/Views/Booking Flow/RotatingHeader.vue';
import {intersection, groupBy, keyBy} from 'lodash';
import {FeathersVuexFindAll, serviceAsDataLayerProduct} from '@/utils';
import VendorProfileDialog from '@/components/Views/Vendor/VendorProfileDialog.vue';
import TimePicker from "@/components/Views/UI/TimePicker.vue";

const MugenScroll = require('vue-mugen-scroll');
@Component({
    components: {TimePicker, VendorProfileDialog, RotatingHeader, HourPicker, VendorBox, MugenScroll},
})
export default class BookingChooseTime extends Vue {

    get currentService(): any {
        return this.services[this.editingService || 0];
    }

    get lastService(): any {
        return this.services[(this.editingService || 1) - 1];
    }

    get startDate() {
        // todo hook up to settings
        return DateTime.local().plus({days: 3});
    }

    get startDateFormatted() {
        return this.startDate.toFormat(CALENDAR_FORMAT);
    }

    public get serviceTitles() {
        return this.services.map((x) => {
            return `<div class="flex headline">Book your <span class="choose-time-service-name"><b>${x.tierModel.name}</b> ${x.name}</span> Service!</div>`;
        });
    }

    @Sync('booking/latitude') public latitude!: number;
    @Sync('booking/longitude') public longitude!: number;
    @Sync('booking/tier') public tier!: any;

    public today = DateTime.local();

    private rememberedService: number | null = null;
    private resetting: boolean = false;
    private skipUndo: boolean = false;
    private timeStep!: number;
    private timeChooserDialog = false;
    private selectedVendor?: any = undefined;
    private selectedDate: string;
    private allVendors: any[] = [];
    private addHoursForToday = 0;
    private loading = true;
    private page = 0;
    private perPage = 14;
    private validBookingHours = [];


    @Sync('booking/services') private services!: any[];
    @Sync('booking/editingService') private editingService!: number | null;
    @Sync('booking/step') private bookingStep!: number;
    @Sync('packages/step') private packageStep!: number;
    @Sync('booking/times') private times!: string[];
    @Call('booking/setTimes') private setTimes!: (times: string[]) => string[];
    @Sync('booking/dates') private dates!: string[];
    @Call('booking/setDates') private setDates!: (dates: string[]) => string[];
    @Sync('booking/vendors') private vendors!: any[];
    @Call('booking/setVendors') private setVendors!: (vendors: any[]) => any[];

    private selectedTime: string | null = `${this.getTimePadded(this.validBookingHourMin)}`;
    private settings: any = null;
    private minimumBookTime = DateTime.local().set({hour:0,minute:0, second:0});
    private maximumBookTime = DateTime.local().plus({years: 1});
    public get pickOneForMeCTA() {
        return `${this.isSM(true) ? 'I\'m In A Hurry, ' : ''} Pick One For Me!`;
    }
    private timeSteps = [
        {
            text: 'Choose a Date',
            miniText: 'Date',
            undo: () => {
            },
            navigate: () => {
            },
        },
        {
            text: 'Choose a Time',
            miniText: 'Time',
            undo: (context: any, serviceIndex: number) => {
                context.times[serviceIndex] = 0;
                // context.setTimes(undefined);
            },
            navigate: () => {
            },
        },
        {
            text: 'Choose a Pro',
            miniText: 'Pro',
            undo: (context: any, serviceIndex: number) => {
                context.vendors[serviceIndex] = undefined;
            },
            navigate: () => {
            },
        },
    ];

    constructor() {
        super();
        this.selectedDate = '';
        this.selectedTime = this.getTimePadded(this.validBookingHourMin);
        this.timeStep = 1;
    }
    public bookedFromDialog(vendor) {
        (this.$refs.vendorProfile as any).open = false;
        this.next(vendor);
    }
    public openVendorProfile(vendor) {
        (this.$refs.vendorProfile as any).openWith(vendor);
    }
    public allowedDates(value: string) {
        const ast = DateTime.fromFormat(value, CALENDAR_FORMAT);
        let useToday = false;
        if (!nil(this.settings)) {
            const earliest = DateTime.local().plus({hours: this.settings.maxBookTime});
            useToday = earliest.hour < this.validBookingHourMax;
        }
        const todaySimple = DateTime.fromFormat(this.today.toFormat(CALENDAR_FORMAT), CALENDAR_FORMAT);
        return ast >= todaySimple.plus({days: useToday ? 0 : 1}) && ast <= this.maximumBookTime;
    }

    public checkIfToday() {
        if (nil(this.settings)) {
            return;
        }
        if (this.isToday) {
            this.minimumBookTime = DateTime.local().plus({hours: this.settings.maxBookTime});
        } else {
            /*const bo = BOOKING_HOURS.getHours();
            this.minimumBookTime = DateTime.fromFormat(this.selectedDate, CALENDAR_FORMAT).set({
                hour: bo[0],
                minute: 0,
                second: 0,
            })*/
        }
    }

    public get validBookingHourMin(){
        return this.validBookingHours[0] || 6;
    }
    public get validBookingHourMax(){
        return this.validBookingHours[this.validBookingHours.length-1] || 22;
    }
    public getTimePadded(hour){
        const isShort = hour.toString().length === 1;
        return `${isShort?'0':''}${hour}:00`;
    }
    public get isToday(){
        return DateTime.local().toFormat(CALENDAR_FORMAT) === this.selectedDate;
    }

    @Watch('timeStep')
    private onTimeStepChanged(value: number, oldValue: number) {
        if (value < oldValue && !this.skipUndo) {
            let indexWas = oldValue - 1;
            const indexIs = value - 1;
            while (indexWas > indexIs) {
                this.timeSteps[indexWas].undo(this, indexWas);
                indexWas--;
            }
        }
        if (this.resetting) {
            this.rememberedService = this.editingService;
            this.editingService = null;
            this.selectedTime = this.getTimePadded(this.validBookingHourMin);
            this.editingService = this.rememberedService;
        }
        this.selectedDate = '';
        this.skipUndo = false;
        this.resetting = false;
    }

    @Watch('editingService')
    public onEditingServiceChanged(value: number, oldValue: number) {
        if (oldValue > value) {
            this.timeStep = 1;
        }
        this.initVendors();
    }

    @Watch('selectedDate')
    private onSelectedDateChanged(value: string, oldValue: string) {
        if (nil(value) || value === '' || nil(this.editingService)) {
            return;
        }
        this.checkIfToday();
        this.dates[this.editingService] = value;
        this.setDates(this.dates);
        this.timeStep++;
    }

    private confirmTimePicker(){
        this.times[this.editingService] = this.selectedTime;
        this.setTimes(this.times);
        window.dataLayer.push({
            event: 'checkout',
            ecommerce: {
                actionField:{'step':4},
                products:this.services.map(serviceAsDataLayerProduct)
            }
        });
        this.timeStep++;
    }

    private previousService() {
        this.resetting = true;
        this.timeStep = 1;
        setTimeout(() => {
            if (nil(this.editingService)) {
                return;
            }
            this.editingService--;
        }, 200);
    }

    private next(chosenVendor?: any) {
        if (nil(this.editingService)) {
            return;
        }
        this.vendors[this.editingService] = chosenVendor;
        const proName = nil(chosenVendor) ? 'Any':`${chosenVendor.firstName} ${chosenVendor.lastName}`;
        if (this.editingService < this.services.length - 1) {
            this.editingService++;
            this.skipUndo = true;
            this.resetting = true;
            this.timeStep = 1;
            this.selectedTime = this.getTimePadded(this.validBookingHourMin);
        } else {
            this.packageMode ? this.packageStep++ : this.bookingStep++;
        }
    }

    public mounted() {
        this.init();
        if (this.startDate.month > DateTime.local().month) {

        }
        this.packageMode
            ? this.packageStep = 2
            : this.bookingStep = 4;
    }

    private async init(near = true) {
        this.initVendors();
        this.settings = await getStoreSettings(this.$FeathersVuex.Setting);
        this.validBookingHours = BOOKING_HOURS.getHours(this.settings);
        this.maximumBookTime = DateTime.local().plus({days: this.settings.maxBookAdvanceDays});
        //this.minimumBookTime = DateTime.local().plus({hours: this.settings.maxBookTime });
    }

    private async initVendors() {
        let response = await this.$FeathersVuex.Vendor.find({
            query: {
                $near: [this.longitude, this.latitude],
            },
        });
        console.log(`pros nearby: ${response.length}`);
        const tiers = await FeathersVuexFindAll(this.$FeathersVuex.Tier, {});
        const tierMap = keyBy(tiers, '_id');
        const cst = this.services[this.editingService].serviceTypes;
        response = response.filter((x) => !nil(x.user, true)).filter((x) => intersection(x.serviceTypes, cst).length >= cst.length);
        console.log(`pros after filtering service type: ${response.length}`);
        response = response.filter((x) => tierMap[x.tier].priceSort >= this.tier.priceSort);
        console.log(`pros after filtering tier: ${response.length}`);
        response = response.sort((a,b)=> b.sortPriority - a.sortPriority);
        this.allVendors = response;
        this.loading = false;
    }

    private async onInfiniteScroll() {
        console.log('doing infinite scroll');
        this.loading = true;
        this.page++;
        // this.visibleVendors = [...this.visibleVendors, ...response.data];
        setTimeout(() => {
            this.loading = false;
        }, 1200);
    }

    get packageMode() {
        return this.$route.path.indexOf('package') > -1;
    }
    get calculatedVendorBoxStyle() {
        let style = 'grid-column-start:1;';
        if (this.isXS(null)) {
            style += 'grid-column-end:2;';
        } else {
            style += 'grid-column-end:3;';
        }
        return style;
    }
    get endIndex() {
        return (this.page * this.perPage) + this.perPage;
    }
    get vendorsRemain() {
        return (this.page * this.perPage) + this.perPage < this.allVendors.length;
    }
    get visibleVendors() {
        return this.allVendors.slice(0, this.endIndex);
    }
    get disableTimeSelection(){
        return this.hourIsTooLate || this.hourIsTooEarly;
    }
    get disableTimeText(){
        return this.hourIsTooEarly ? 'Booking is Too Early' : this.hourIsTooLate ? 'Booking is Too Late' : 'Book For This Time'
    }
    get hourIsTooEarly(){

        const st = DateTime.fromFormat(this.selectedTime, 'HH:mm');
        if(this.isToday) {
            return st < this.minimumBookTime;
        } else {
            return st.hour < this.validBookingHourMin;
        }
    }
    get hourIsTooLate(){
        const st = DateTime.fromFormat(this.selectedTime, 'HH:mm');
        return st.hour > this.validBookingHourMax;
    }
}
